import request from '@/blocks/request';

export function getArticleList(params) {
  return request({
    url: `/activities/${process.env.VUE_APP_H5_KEY}/intf13615`,
    params,
  });
}

export function getArticleDetail(params) {
  return request({
    useLoading: true,
    baseURL: process.env.VUE_APP_PANGKU_WWW_CDN,
    url: `/v1/offical/content/get_article_detail`,
    params,
  });
}

export function getVideoList(params) {
  return request({
    url: `/activities/bjcz200918/auto_show201611`,
    params,
  });
}
